import {useEffect, useState} from "react";
import APIService from "../../services/ApiService";

const useLevels = () => {
    const [levels, setLevels] = useState([]);

    useEffect(() => {
        APIService.getLevelList()
            .then((levelObj) => {
            setLevels(levelObj.levelCourseDtos);
        }).catch((error) => {
            console.log(error);
            //retry
            APIService.getLevelList().then((levelObj) => {
                setLevels(levelObj.levelCourseDtos);
            })
        })
    }, []);

    return levels;
}

export default useLevels;